import { CopyClipBoardBlack } from "assets/icons";
import Button from "components/BaseWidgets/button";
import Modal from "components/BaseWidgets/modal";
import "./style.scss";
import { Form, message } from "antd";
import Input from "components/BaseWidgets/form/input";

const PaymentSuccess = ({
  open,
  onCancel,
  title,
  description,
  status,
  pin,
  code,
}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      message.success("Verification code copied");
    } catch (err) {
      message.error("Failed to copy code");
    }
  };
  return (
    <Modal
      isOpen={open}
      className="success-modal-wrapper"
      onCancel={onCancel}
      width={600}
      title={
        <div className="flex flex-col gap-1">
          <span className="font-title-lg fw-700 leading-3">{title}</span>
          <p className="font-body-md2 leading-5">{description}</p>
        </div>
      }
      closable
    >
      <div className="modal-content">
        <Form.Item label="Pin code" className="custom-error pin-code-input">
          <Input type="number" value={pin || ""} disabled={status === "0"} />
        </Form.Item>
      </div>

      <div className="verification-code-card">
        <span className="verification-label">Unique verification code</span>

        <div className="verification-code-row">
          <span className="verification-code">{code}</span>

          <Button
            type="button"
            className="copy-btn"
            onClick={handleCopy}
            variant="custom"
          >
            <CopyClipBoardBlack />
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentSuccess;
